import * as React from 'react';

import ManagersRolesStore from './ManagersRolesStore';
import { ManagersRolesStoreContext } from './context';

const useManagersRolesStore = (): ManagersRolesStore => {
  const managersRolesContext = React.useContext(ManagersRolesStoreContext);

  return managersRolesContext.store as ManagersRolesStore;
};

export { useManagersRolesStore, ManagersRolesStore };
export * from './context';
